import { InvoiceBillingStage } from '../../enums/invoiceBillingStage'

export const isDepositInvoice = (billingStage?: InvoiceBillingStage): boolean =>
  billingStage === InvoiceBillingStage.Deposit
